export default __webpack_public_path__ + "static/media/recordpayment.040528aa.svg";